import { Component, OnInit } from "@angular/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgIf } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LocalizationModule } from "src/app/components/localization";
import { MatDialog } from "@angular/material/dialog";
import { GetStartedDialogComponent } from "../get-started-dialog/get-started-dialog.component";
import { TranslocoService } from "@ngneat/transloco";
import { ApplicationService } from "src/app/shared/constants/application.service";

@Component({
  selector: "app-home-header",
  templateUrl: "./home-header.component.html",
  standalone: true,
  imports: [
    MatSidenavModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatSelectModule,
    LocalizationModule,
  ],
  styleUrls: ["./home-header.component.scss"],
})
export class HomeHeaderComponent implements OnInit {
  titles: any = [];

  currentTitleIndex = 0;
  currentTitle: any = undefined;
  isHidden = false;

  showJoinUventex = false;

  constructor(
    private dialog: MatDialog,
    private transloco: TranslocoService,
    private applicationService: ApplicationService
  ) {
    this.loadTitles();
  }

  loadTitles() {
    this.titles = [
      {
        black: "HOME_HEADER_TITLE_1_BLACK",
        color: "HOME_HEADER_TITLE_1_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_2_BLACK",
        color: "HOME_HEADER_TITLE_2_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_3_BLACK",
        color: "HOME_HEADER_TITLE_3_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_4_BLACK",
        color: "HOME_HEADER_TITLE_4_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_5_BLACK",
        color: "HOME_HEADER_TITLE_5_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_6_BLACK",
        color: "HOME_HEADER_TITLE_6_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_7_BLACK",
        color: "HOME_HEADER_TITLE_7_COLOR",
        black2: "",
      },
      {
        black: "HOME_HEADER_TITLE_8_BLACK",
        color: "HOME_HEADER_TITLE_8_COLOR_NEW",
        black2: "",
      },
    ];
    this.currentTitle = this.titles[this.currentTitleIndex];
  }

  ngOnInit(): void {
    this.applicationService.aauSubdomain$.subscribe((subdomain) => {
      if(subdomain === null){
        return;
      }
      this.showJoinUventex = !subdomain;
    });
    setInterval(() => {
      this.fadeOutIn();
    }, 4000);
  }

  fadeOutIn(): void {
    // Trigger fade-out effect
    this.isHidden = true;

    // Change text after fade-out completes
    setTimeout(() => {
      this.currentTitleIndex =
        (this.currentTitleIndex + 1) % this.titles.length;
      this.currentTitle = this.titles[this.currentTitleIndex];
      this.isHidden = false; // Fade back in
    }, 500);
  }

  openDialog() {
    let dialogWidth = "547px";
    if (window.innerWidth < 690) {
      if (window.innerWidth > 600) {
        dialogWidth = "450px";
      } else if (window.innerWidth > 500) {
        dialogWidth = "400px";
      } else if (window.innerWidth > 400) {
        dialogWidth = "350px";
      } else {
        dialogWidth = "300px";
      }
    }

    const labels = [
      "EMAIL",
      "GET_STARTED_CONTACT",
      "GET_STARTED_IN_MEANTIME",
      "GET_STARTED_INTEREST",
      "GET_STARTED_INTEREST_1",
      "GET_STARTED_INTEREST_2",
      "GET_STARTED_INTEREST_3",
      "GET_STARTED_INTEREST_4",
      "GET_STARTED_INTEREST_5",
      "GET_STARTED_INTEREST_6",
      "GET_STARTED_INTEREST_7",
      "GET_STARTED_LEARN_MORE",
      "GET_STARTED_MESSAGE_PLACEHOLDER",
      "GET_STARTED_PLEASE_ENTER_EMAIL",
      "GET_STARTED_PLEASE_ENTER_MESSAGE",
      "GET_STARTED_PLEASE_ENTER_VALID_EMAIL",
      "GET_STARTED_PLEASE_ENTER_YOUR_NAME",
      "GET_STARTED_PLEASE_SELECT_AN_OPTION",
      "GET_STARTED_PLESASE_SHARE",
      "GET_STARTED_SUBMIT_AND_START",
      "GET_STARTED_THANKS",
      "GET_STARTED_WE_ARE_EXCITED",
      "GET_STARTED_WELCOME",
      "GET_STARTED_WITH_UVENTEX",
      "MESSAGE",
      "NAME",
    ];

    let labelMap: any = {};
    for (const label of labels) {
      const trans = this.transloco.translate(label);
      labelMap[label] = trans;
    }

    this.dialog.open(GetStartedDialogComponent, {
      width: dialogWidth,
      panelClass: "custom-dialog-container",
      data: {
        labelMap: labelMap,
      },
    });
  }
}
